import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;

  header h6 {
    margin-left: 2rem;
  }

  header.MuiAppBar-colorPrimary {
    transition: 0.3s;
  }

  @media (min-width: 769px) {
    header.MuiAppBar-colorPrimary {
      width: ${(props) =>
        props.open ? 'calc(100% - 280px)' : 'calc(100% - 6rem)'};
      margin-left: ${(props) => (props.open ? '280px' : '6rem')};
    }
  }

  @media (max-width: 768px) {
    header.MuiAppBar-colorPrimary {
      width: ${(props) => (props.open ? 'calc(100% - 240px)' : '100%')};
      margin-left: 0;
    }
  }
`;

export const NavBar = styled.nav`
  background: ${(props) => (props.open ? 'transparent' : '#fff')};
  width: ${(props) => (props.open ? '280px' : '8rem')};

  .drawer-desktop > div {
    width: ${(props) => (props.open ? '280px' : '6rem')};
    transition: 0.3s;
    overflow: hidden;
  }

  @media (max-width: 768px) {
    width: 0;
  }
`;

export const Navi = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  width: ${(props) => (props.open ? '280px' : '8rem')};

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }

  ::-webkit-scrollbar-track {
    background-color: #eaeaea;
  }
`;

export const Logo = styled.div`
  width: ${(props) => (props.open ? '100%' : '6rem')};
  height: 4.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s;
  color: #fff;

  img {
    ${({ open }) =>
      open
        ? css`
            max-height: 5rem;
          `
        : css`
            max-width: 6rem;
            max-height: 3.5rem;
          `}
  }

  @media (max-width: 768px) {
    width: calc(100% - 4rem);

    img {
      max-height: 3.5rem;
    }
  }

  @media (min-width: 600px) {
    height: 6.4rem;
  }
`;

export const Main = styled.div`
  width: calc(100vw - ${(props) => (props.open ? '33.5rem' : '11.5rem')});
  min-height: calc(100vh - 10.5rem);
  height: auto;
  margin-left: ${(props) => (props.open ? '2rem' : '0')};
  margin-top: 8.5rem;
  margin-bottom: 2rem;
  transition: 0.3s;
  background: #fff;
  padding: 1rem;
  border-radius: 0.3rem;

  @media (max-width: 768px) {
    width: calc(100% - 4rem);
    margin-left: 2rem;
  }

  @media (max-width: 599px) {
    margin-top: 7.5rem;
  }
`;

export const Avatar = styled.div`
  display: flex;
  align-items: center;

  svg {
    font-size: 3rem;
    margin-right: 1rem;
  }

  p {
    font-size: 1.5rem;
    line-height: 1.4rem;

    text-align: left;

    small {
      display: block;
      color: rgba(255, 255, 255, 0.6);
    }

    @media (max-width: 425px) {
      display: none;
    }
  }
`;
